export class Return {
  constructor(difference) {
    this.width = 118
    this.height = 32
    this.top = 20
    this.left = 20
    this.innerElement = "cxReturn"
    this.content = "返回上一级"
    this.textLimitLines = 1
    this.openBlankPage = false
    this.linkUrl = ""
    this.accessRulers = []
    this.fontFamily = "sans-serif"
    this.fontSize = 14
    this.lineHeight = 14
    this.fontWeight = "400"
    this.borderTypeFlag = 2
    this.bgColor = "rgb(61, 130, 242)"
    this.clipSize = "cover"
    this.repeatType = "no-repeat"
    this.alignType = "center center"
    this.color = "rgba(255,255,255,1)"
    this.textIsThemeColor = false
    this.bgType = "自定义"
    this.bgColorIsThemeColor = false
    this.showIcon = false
    this.showReturnText = false
    this.letterSpacing = 0
    this.fontStyle = "normal"
    this.rotate = 0
    this.textDecoration = "none"
    this.textAlign = "left"
    this.writingMode = "horizontal-tb"
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderColor = "#3D82F2"
    this.borderWidth = 1
    this.borderStyle = "solid" // solid, dashed, dotted
    this.borderIsThemeColor = false
    this.boxShadowColor = ["rgba(61, 130, 242, 0.5)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    this.iconPosition = "left" // left,right
    this.iconSrc = "icon-portal-return"
    this.iconType = "icon" // img,icon 图片和字体图标
    this.iconWidth = 16
    this.iconMargin = 4
    this.iconColorIsThemeColor = false
    this.iconColor = "#fff"
    this.opacity = 100
    this.background = []
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
